import { UIText2 } from '@cian/ui-kit';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';
import { Link } from '@/packages/shared-ui';
import { noop } from '@/packages/utils/noop';

import style from './Breadcrumbs.css';

type BreadcrumbsProps = {
  breadcrumbs: Array<{
    title: string;
    url: string;
  }>;
};

export const Breadcrumbs = memoWithDisplayName<BreadcrumbsProps>(props => {
  const { breadcrumbs } = props;

  return (
    <ul itemScope className={style['list']} data-testid="breadcrumbs" itemType="http://schema.org/BreadcrumbList">
      {breadcrumbs.map((breadcrumb, index) => {
        return (
          <li
            itemScope
            className={style['item']}
            data-testid="breadcrumbs.item"
            itemProp="itemListElement"
            itemType="http://schema.org/ListItem"
            key={breadcrumb.title}
          >
            <Link
              behaviour="hover_gray_to_primary"
              href={breadcrumb.url}
              itemProp="item"
              title={breadcrumb.title}
              track={
                /**
                 * @description В пункте 8 описывается контракт, нет требований по треку действия
                 * @link https://conf.cian.tech/pages/viewpage.action?pageId=1344505184#id-Редизайнвыдачивкоммерческой[2023]-Интерактивныеэлементыбезаналитики
                 */
                noop
              }
            >
              <>
                <UIText2 color="current_color" itemProp="name" whiteSpace="nowrap">
                  {breadcrumb.title}
                </UIText2>
                <meta content={`${index + 1}`} itemProp="position" />
              </>
            </Link>
          </li>
        );
      })}
    </ul>
  );
}, 'Breadcrumbs');
